module.exports = {
  presets: [
    '@vue/cli-plugin-babel/preset'
  ]
}
